import './Navbar.scss';
import React from 'react';


const Navbar = () => {
    return(
        <div className="navbar">
            <a href="#aboutus">About Us</a>
            <a href="#foryou">For You</a>
            <a href="#services">Services</a>
            <a href="#blog">Blog</a>
            <a href="#vlog">Vlog</a>
            <a href="#contact">Contact</a>
        </div>
    )
}

export default Navbar;

